import styled, { css } from 'styled-components';
import { device, typography } from '@/styles/helpers';
import theme from '@/theme';

export const overlayStyle = {
  opacity: '1',
  borderRadius: '12px',
  zIndex: 10,
};

export const overlayInnerStyle = {
  background: theme.grayLightColor,
  maxWidth: '240px',
  borderRadius: '12px',
  border: 'none',
  color: theme.whiteColor,
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center' as const,
  wordBreak: 'break-word' as const,
};

export const ScPrizeWheel = styled.div`
  position: relative;
  z-index: 10;
  height: 100%;
`;

export const ScWinningPrize = styled.div<{ isOpen: boolean }>`
  overflow: ${({ isOpen }) => (isOpen ? 'scroll' : 'hidden')};
  height: 100%;
  background-color: ${({ theme }) => theme.green4Color};
  border-radius: 50%;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  & .inside {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 324px;
    width: 100%;
    margin: 0 auto;
    padding: 121px 0 95px;

    &.de {
      padding: 95px 0;
    }

    ${({ isOpen }) =>
      !isOpen &&
      css`
        height: 100%;
      `};

    @media (${device.mobile}) {
      &,
      &.de {
        max-width: 220px;
        padding: 50px 0 57px;
      }
      &.de {
        padding-top: 30px;
      }
    }
  }

  & .congrats {
    font-size: 28px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.01em;
    margin-bottom: 32px;
    text-align: center;
    text-transform: uppercase;

    @media (${device.mobile}) {
      font-size: 18px;
      font-weight: 700;
      line-height: 20px;
      margin-bottom: 20px;
    }
  }

  & .description {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.01em;
    text-align: center;

    @media (${device.mobile}) {
      font-size: 10px;
      line-height: 16px;
      margin-bottom: 8px;
      letter-spacing: 0.1px;
    }
  }

  & .prize-info {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0 32px;

    @media (${device.mobile}) {
      margin: 0 0 20px;
    }
  }

  & .prize {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0.03em;
    margin-right: 8px;
    text-transform: capitalize;

    @media (${device.mobile}) {
      font-size: 20px;
      line-height: 25px;
    }
  }

  & .info {
    position: relative;
    display: inline-flex;
    cursor: pointer;
  }

  & .btn-container {
    position: relative;
    max-width: 280px;
    width: 100%;
    margin: 0 auto;

    @media (${device.mobile}) {
      max-width: none;
      button {
        .text {
          font-size: 14px;
          line-height: 20px;
          font-weight: 700;
        }
      }
    }
  }

  & .btn_wrapper {
    display: flex;
    justify-content: center;
  }
`;

export const ScTermsSection = styled.div<{ isOpen: boolean }>`
  position: relative;
  margin-top: 16px;

  @media (${device.mobile}) {
    margin-top: 8px;
  }

  & .header {
    padding-bottom: 24px;
  }

  .content-box {
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows 0.2s ease 0s;
    justify-content: center;

    & .content {
      position: relative;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      word-break: break-word;
      text-align: left;
      @media (${device.mobile}) {
        ${typography.caption2regular};
      }
    }

    & .bonus {
      text-transform: capitalize;
    }
  }
`;

export const ScTermsButton = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  cursor: pointer;
  margin-bottom: 8px;
  column-gap: 8px;
  font-size: 14px;
  line-height: 20px;

  @media (${device.mobile}) {
    font-size: 10px;
    line-height: 12px;
  }

  & > i {
    transition: rotate 0.2s ease-in-out;
    rotate: ${({ isOpen }) => (isOpen ? '-90deg' : '90deg')};
    transform-origin: center;
    font-size: 14px;
    @media (${device.mobile}) {
      font-size: 12px;
    }
  }

  @media (hover: hover) {
    &:hover {
      & > i {
        rotate: -90deg;
      }
    }
  }
`;
